// client/src/pages/admin/ManageUsers.js

import React, { useEffect, useState } from 'react';
import axios from 'axios';

export default function ManageUsers() {
  const token = localStorage.getItem('authToken');
  const [users, setUsers] = useState([]);

  // For inline editing
  const [editingId, setEditingId] = useState(null);
  const [editName, setEditName] = useState('');
  const [editEmail, setEditEmail] = useState('');
  const [editIsAdmin, setEditIsAdmin] = useState(false);

  const fetchUsers = async () => {
    try {
      const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/admin/users`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUsers(data);
    } catch (err) {
      console.error('Error fetching users:', err);
    }
  };

  useEffect(() => {
    fetchUsers();
    // eslint-disable-next-line
  }, []);

  // Start editing a user
  const handleEdit = (u) => {
    setEditingId(u._id);
    setEditName(u.name);
    setEditEmail(u.email);
    setEditIsAdmin(u.isAdmin);
  };

  // Cancel edit
  const handleCancel = () => {
    setEditingId(null);
    setEditName('');
    setEditEmail('');
    setEditIsAdmin(false);
  };

  // Save changes
  const handleSave = async (userId) => {
    try {
      await axios.put(
        `${process.env.REACT_APP_API_URL}/api/admin/users/${userId}`,
        {
          name: editName,
          email: editEmail,
          isAdmin: editIsAdmin
        },
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );
      alert('User updated');
      setEditingId(null);
      fetchUsers();
    } catch (err) {
      console.error('Error updating user:', err);
      alert('Failed to update user');
    }
  };

  // Delete user
  const handleDeleteUser = async (userId) => {
    if (!window.confirm('Are you sure you want to delete this user?')) return;
    try {
      await axios.delete(
        `${process.env.REACT_APP_API_URL}/api/admin/users/${userId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert('User deleted');
      fetchUsers();
    } catch (err) {
      console.error('Error deleting user:', err);
      alert('Failed to delete user');
    }
  };

  return (
    <div>
      <h1 className="text-2xl font-bold mb-4">Manage Users</h1>
      {users.map(u => (
        <div key={u._id} className="border p-3 rounded mb-2">
          {editingId === u._id ? (
            <>
              <label className="block mb-1 font-medium">Name:</label>
              <input
                className="border p-2 w-full mb-2"
                value={editName}
                onChange={e => setEditName(e.target.value)}
              />

              <label className="block mb-1 font-medium">Email:</label>
              <input
                className="border p-2 w-full mb-2"
                value={editEmail}
                onChange={e => setEditEmail(e.target.value)}
              />

              <div className="mb-2 flex items-center space-x-2">
                <label className="font-medium">Admin?</label>
                <input
                  type="checkbox"
                  checked={editIsAdmin}
                  onChange={e => setEditIsAdmin(e.target.checked)}
                />
              </div>

              <button
                onClick={() => handleSave(u._id)}
                className="bg-primaryGreen text-white px-3 py-1 rounded hover:bg-green-500 mr-2"
              >
                Save
              </button>
              <button
                onClick={handleCancel}
                className="bg-gray-400 text-white px-3 py-1 rounded hover:bg-gray-500"
              >
                Cancel
              </button>
            </>
          ) : (
            <>
              <p><strong>Name:</strong> {u.name}</p>
              <p><strong>Email:</strong> {u.email}</p>
              <p><strong>Admin:</strong> {u.isAdmin ? 'Yes' : 'No'}</p>
              <p><strong>Address:</strong> {u.address}</p>
              <div className="mt-2 space-x-2">
                <button
                  onClick={() => handleEdit(u)}
                  className="bg-yellow-500 text-white px-3 py-1 rounded hover:bg-yellow-600"
                >
                  Edit
                </button>
                <button
                  onClick={() => handleDeleteUser(u._id)}
                  className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
                >
                  Delete
                </button>
              </div>
            </>
          )}
        </div>
      ))}
    </div>
  );
}
